import React, { useState, useRef } from 'react';
import { QRCodeSVG } from 'qrcode.react';

export default function CheckinModal({ onCheckin, onClose }) {
  const [phase, setPhase] = useState('form'); // 'form' | 'qr'
  const [name, setName] = useState('');
  const [chips, setChips] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [sessionUrl, setSessionUrl] = useState('');
  const [playerName, setPlayerName] = useState('');
  const [pin, setPin] = useState('');
  const nameRef = useRef(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const trimmedName = name.trim();
    const chipsNum = parseInt(chips, 10);
    if (!trimmedName) { setError('Name erforderlich'); return; }
    if (!chipsNum || chipsNum <= 0) { setError('Chips-Anzahl erforderlich'); return; }
    setError('');
    setLoading(true);
    const result = await onCheckin(trimmedName, chipsNum);
    setLoading(false);
    if (result?.error) {
      setError(result.error);
      return;
    }
    setSessionUrl(result.sessionUrl);
    setPlayerName(trimmedName);
    setPin(result.pin || '');
    setPhase('qr');
  };

  const handleNewPlayer = () => {
    setName('');
    setChips('');
    setError('');
    setSessionUrl('');
    setPlayerName('');
    setPin('');
    setPhase('form');
    setTimeout(() => nameRef.current?.focus(), 50);
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-panel" onClick={e => e.stopPropagation()}>
        {phase === 'form' && (
          <>
            <h3 className="modal-title">NEUER SPIELER</h3>
            <form onSubmit={handleSubmit} className="checkin-form">
              <div className="checkin-field">
                <label className="checkin-label">Name</label>
                <input
                  ref={nameRef}
                  className="checkin-input"
                  type="text"
                  value={name}
                  onChange={e => setName(e.target.value)}
                  placeholder="Spielername"
                  maxLength={20}
                  autoFocus
                />
              </div>
              <div className="checkin-field">
                <label className="checkin-label">Chips</label>
                <input
                  className="checkin-input checkin-input-chips"
                  type="number"
                  inputMode="numeric"
                  value={chips}
                  onChange={e => setChips(e.target.value)}
                  placeholder="100"
                  min={1}
                />
              </div>
              {error && <div className="checkin-error">{error}</div>}
              <div className="checkin-actions">
                <button type="button" className="modal-btn-secondary" onClick={onClose}>
                  ABBRECHEN
                </button>
                <button type="submit" className="modal-btn-primary" disabled={loading}>
                  {loading ? '...' : 'EINCHECKEN'}
                </button>
              </div>
            </form>
          </>
        )}
        {phase === 'qr' && (
          <>
            <h3 className="modal-title">TABLET ÜBERGEBEN</h3>
            <p className="checkin-player-name">{playerName}</p>
            <div className="checkin-qr-wrapper">
              <QRCodeSVG
                value={sessionUrl}
                size={220}
                bgColor="#1a1a0a"
                fgColor="#d4a535"
                level="M"
              />
            </div>
            <p className="checkin-qr-hint">QR-Code auf Spieler-Gerät scannen</p>
            {pin && (
              <div className="checkin-pin-box">
                <span className="checkin-pin-label">Kein Kamera? PIN eingeben:</span>
                <span className="checkin-pin-code">{pin.slice(0,3)} {pin.slice(3)}</span>
              </div>
            )}
            <div className="checkin-actions">
              <button className="modal-btn-secondary" onClick={onClose}>
                FERTIG
              </button>
              <button className="modal-btn-primary" onClick={handleNewPlayer}>
                NÄCHSTER SPIELER
              </button>
            </div>
          </>
        )}
      </div>
    </div>
  );
}
